import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Apple3DScroll from './scroll';
import Impressum from './pages/Impressum';
import AdminApp from './admin/AdminApp';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center justify-center min-h-screen bg-[#0a0a0a] text-white p-8">
          <div className="max-w-md text-center">
            <h1 className="text-2xl font-bold mb-4">WebGL Error</h1>
            <p className="text-gray-400 mb-4">
              {this.state.error?.message || 'Could not initialize WebGL'}
            </p>
            <p className="text-sm text-gray-500 mb-6">
              Please close some browser tabs and refresh the page.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-3 bg-blue-500 rounded-lg hover:bg-blue-600"
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/" element={<Apple3DScroll />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/admin/*" element={<AdminApp />} />
      </Routes>
    </ErrorBoundary>
  );
}

export default App;